<!-- #6 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex custom-page">
      <div
        class="text-h6 py-0 my-0 pl-0 mr-5"
        style="color: #23468c; font-weight: 500"
      >
        Download Label
      </div>
      <v-spacer></v-spacer>
      <v-btn
        @click="download"
        color="primary"
        :loading="downloader"
        small
        v-if="
          checkPermission(
            'app_consignment_order:download_multiple_package_label'
          )
        "
        >Download</v-btn
      >
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-data-table
      v-model="selectedPackages"
      :headers="headers"
      :items="packages"
      :options.sync="options"
      :server-items-length="total"
      :items-per-page="500"
      :loading="packagesLoader"
      item-key="id"
      show-select
      :hide-actions="true"
      class="elevation-1 mt-7"
      :footer-props="{
        'disable-items-per-page': true,
        'items-per-page-options': [500],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus',
      }"
    >
      <template v-slot:top>
        <v-row>
          <v-col class="text-center py-0 mb-0 mt-2">
            <p class="pt-2 text-left px-5 d-flex mb-0">
              <strong>Label Format</strong>
              <v-radio-group
                mandatory
                class="pl-4 mt-0 pt-0"
                v-model="selectedFormat"
                row
              >
                <v-radio label="PDF" value="pdf"></v-radio>
              </v-radio-group>
            </p>
          </v-col>
          <v-col class="text-center py-0 mb-0 mt-2">
            <p class="pt-2 text-left pl-4 d-flex mb-0">
              <strong>Label Size</strong>
              <v-radio-group
                mandatory
                v-model="selectedSize"
                row
                class="mt-0 pl-6 pt-0"
              >
                <v-radio label="4 x 6 inch label" value="4x6"></v-radio>
              </v-radio-group>
            </p>
          </v-col>
          <v-col cols="12" md="6" sm="12" xs="12" class="py-0 pt-2"> </v-col>
        </v-row>
        <template>
          <v-form>
            <v-row class="custom-row pl-5 pr-5">
              <v-col cols="12" sm="3" v-if="userCategory.user_category === 3">
                <v-autocomplete
                  v-model="client_name"
                  :items="clients"
                  outlined
                  dense
                  chips
                  item-text="name"
                  item-value="id"
                  small-chips
                  label="Client name"
                  @click:clear="clearInput('client_name')"
                  @focus="getClientList"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-text-field
                  v-model="tracking_number"
                  label="Tracking No."
                  outlined
                  clearable
                  @click:clear="clearInput('tracking_number')"
                  class="heights"
                  height="10px"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="origin_country"
                  :items="countries"
                  outlined
                  dense
                  chips
                  small-chips
                  label="Origin Country"
                  item-text="name"
                  item-value="id"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-autocomplete
                  v-model="destination_country"
                  :items="countries"
                  outlined
                  dense
                  chips
                  small-chips
                  item-text="name"
                  item-value="id"
                  label="Destination Country"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      placeholder="From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearInput('from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                    :max="getEndDate"
                    :min="getStartDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      placeholder="To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearInput('to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                    :max="getEndDate"
                    :min="getStartDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                class="offset-md-0"
                :class="userCategory.user_category == 1 ? 'offset-md-3' : ''"
              >
                <v-btn color="white" @click="clearAll" style="float: right"
                  >Clear</v-btn
                >
                <v-btn
                  color="primary"
                  class="success mr-5"
                  @click="searchAll"
                  style="float: right"
                  >Search</v-btn
                >
                <v-btn
                  color="primary"
                  @click="(openPopup = true), clearAll()"
                  style="float: right"
                  class="mr-5"
                  >Excel Search</v-btn
                >
              </v-col>
            </v-row>
            <v-divider class="mb-2 mt-2"></v-divider>
          </v-form>
        </template>
      </template>
      <template v-slot:[`item.tracking_no`]="{ item }">
        <label @click="fetchTrackingDetails(item)">
          <a>{{ item.tracking_no }}</a>
        </label>
      </template>
      <template v-slot:[`item.total_value`]="{ item }">
        {{ item.total_value }} {{ item.currency_code }}
      </template>
      <template #footer.prepend>
        <v-spacer />
      </template>
    </v-data-table>
    <v-dialog v-model="openPopup" width="600" @keydown.esc="close()" persistent>
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>Download Label</v-toolbar-title>
          <i class="caption red--text ml-4"> * required field</i>
        </v-toolbar>
        <v-divider></v-divider>

        <v-card-text class="pa-4">
          <v-form ref="formExcel" lazy-validation>
            <div class="text-center py-0">
              <v-autocomplete
                v-model="selectedtype"
                :items="types"
                hide-no-data
                hide-details
                item-text="text"
                item-value="value"
                label="Search By"
                placeholder="Start typing to Search"
                class="pb-2 pt-0 pl-2 text-center required"
                :rules="[(v) => !!v || 'Please select Type']"
                @change="searchfile = null"
              ></v-autocomplete>
              <v-file-input
                v-model="searchfile"
                accept=".xlsx"
                label="Upload your File"
                clearable
                class="required"
                :rules="[(v) => !!v || 'File is required.']"
              >
              </v-file-input>
              <div class="text-left ml-3 pb-4 pt-2">
                <v-btn
                  small
                  class="info"
                  @click="downloadTemplate()"
                  :loading="downloaderTemp"
                  >Download Template</v-btn
                >
                <v-btn
                  small
                  color="primary"
                  class="ml-4"
                  :loading="uploaderPUpload"
                  @click="fetchByExcel()"
                  >Search
                </v-btn>
                <v-btn
                  small
                  color="white"
                  class="ml-4"
                  @click="(openPopup = false), $refs.formExcel.reset()"
                  >Cancel</v-btn
                >
              </div>
            </div>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-col>
</template>
<script>
import XLSX from "xlsx";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      types: [
        { text: "Tracking Number", value: "tracking_number" },
        { text: "Reference Number", value: "reference_number" },
      ],
      dateMenu: false,
      dateMenuTo: false,
      from_date: "",
      to_date: "",
      packages: [],
      client_name: "",
      origin_country: "",
      destination_country: "",
      tracking_number: "",
      selectedPackages: [],
      openPopup: false,
      headers: [
        {
          text: "Tracking No.",
          value: "tracking_no",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Order Reference No.",
          value: "order_ref",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Client Name",
          value: "client_name",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Origin Country",
          value: "origin_country",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Destination Country",
          value: "destination_country",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        // {
        //   text: "Carrier Name",
        //   value: "has_tag__carrier_id__name",
        //   class: "body-1 font-weight-bold",
        //   sortable: false,
        // },
        // {
        //   text: "Payment Type",
        //   value: "payment_type",
        //   class: "body-1 font-weight-bold",
        //   sortable: false,
        // },

        {
          text: "Value",
          value: "total_value",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
      ],
      searchOptions: [
        {
          text: "Tracking #",
          value: "tracking_no",
        },
        {
          text: "Client Name",
          value: "client",
        },
        {
          text: "Origin Country",
          value: "origin_country",
        },
        {
          text: "Destination Country",
          value: "destination_country",
        },
      ],
      total: 0,
      packagesLoader: false,
      search: null,
      options: {},
      searchType: null,
      file: null,
      selectedFormat: "pdf",
      selectedSize: "4x6",
      downloader: false,
      bagNumber: "",
      fileTrackingNumbers: [],
      countries: [],
      filtersArr: {},
      clients: [],
      selectedtype: "",
      searchfile: null,
      downloaderTemp: false,
    };
  },
  computed: {
    getStartDate() {
      var endDate = new Date();
      endDate.setMonth(endDate.getMonth() - 6);
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    ...mapGetters(["userCategory"]),
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "has_tag__carrier_id__name"
          : true;
      });
    },
  },
  watch: {
    options: {
      handler() {
        this.fetchPackage();
        this.selectedPackages = [];
      },
      deep: true,
    },
  },
  mounted() {
    this.getCityList();
    this.getClientList();
  },
  methods: {
    ...mapActions([
      "getAllPackages",
      "downloadPackageLabels",
      "snackBar",
      "getCountries",
      "fetchClient",
      "getLabelDetailsExcel",
      "downloadLabelTemplate",
    ]),

    downloadTemplate() {
      this.downloaderTemp = true;
      this.downloadLabelTemplate()
        .then((res) => {
          this.fileDownload(res);
          this.downloaderTemp = false;
        })
        .catch(() => {
          this.downloaderTemp = false;
        });
    },
    fetchByExcel() {
      this.options.page = 1;
      if (!this.$refs.formExcel.validate()) return;
      this.uploaderPUpload = true;
      const payload = new FormData();
      payload.append("file", this.searchfile);
      payload.append("type", this.selectedtype);
      payload.append("page", 1);
      payload.append("itemsPerPage", 500);

      this.getAllPackages(payload)
        .then((res) => {
          this.packagesLoader = false;
          this.packages = res.data.records;
          this.total = res.data.total;
          this.uploaderPUpload = false;
          this.openPopup = false;
          this.$refs.formExcel.reset();
          this.selectedPackages = [];
        })
        .catch(() => {
          this.packagesLoader = false;
          this.uploaderPUpload = false;
        });
    },
    getClientList() {
      if (this.clients.length) return;
      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.fetchClient({
          fields: "id,name,service",
          pagination: 0,
          service: "clickdna,fulfillment_wid_last_mile",
        }).then((res) => {
          this.clients = res.data;
        });
      }
    },
    getCityList() {
      this.getCountries().then((res) => {
        res.data.forEach((e) => {
          return this.countries.push(e);
        });
      });
    },
    allFilters() {
      let obj = {
        client_name: this.client_name,
        origin_country: this.origin_country,
        destination_country: this.destination_country,
        tracking_number: this.tracking_number,
        from_date: this.from_date,
        to_date: this.to_date,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    searchAll() {
      this.options.page = 1;
      this.allFilters();
      this.packagesLoader = true;
      this.getAllPackages({ ...this.options, ...this.filtersArr })
        .then((res) => {
          this.packagesLoader = false;
          this.packages = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },
    clearAll() {
      (this.client_name = ""),
        (this.origin_country = ""),
        (this.destination_country = ""),
        (this.tracking_number = ""),
        (this.from_date = ""),
        (this.to_date = "");
      this.searchAll();
    },
    fetchPackage() {
      this.packages = [];
      this.packagesLoader = true;
      this.getAllPackages({
        ...this.options,
        ...this.filtersArr,
        search: this.search,
        type: this.searchType,
        status: this.statusType,
      })
        .then((res) => {
          this.packagesLoader = false;
          this.packages = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.packagesLoader = false;
        });
    },
    download() {
      if (
        this.selectedPackages.length === 0 &&
        !this.bagNumber &&
        this.fileTrackingNumbers.length === 0
      ) {
        return this.snackBar({
          color: "error",
          message: "Please select atleast one record.",
        });
      }
      const trackingNumbers = [];
      if (this.selectedPackages.length) {
        this.selectedPackages.forEach((i) => {
          trackingNumbers.push(i.id);
        });
      }
      if (this.fileTrackingNumbers.length) {
        trackingNumbers.push(...this.fileTrackingNumbers);
      }
      if (this.bagNumber) {
        trackingNumbers.push(this.bagNumber);
      }
      this.downloader = true;
      this.downloadPackageLabels({
        format: this.selectedFormat,
        size: this.selectedSize,
        data: {
          tracking_numbers: trackingNumbers.filter(
            (v, i, a) => a.indexOf(v) === i
          ),
        },
      })
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
          this.selectedPackages = [];
        })
        .catch(() => {
          this.downloader = false;
          this.selectedPackages = [];
        });
    },
    upload() {
      if (!this.file) return;
      const reader = new FileReader();
      const $v = this;
      reader.onload = function (e) {
        let data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const first_worksheet = workbook.Sheets[workbook.SheetNames[0]];
        data = XLSX.utils.sheet_to_json(first_worksheet);
        if (data.length === 0) return;
        $v.fileTrackingNumbers = data.map((i) => i["Tracking Number"]);
      };
      reader.readAsArrayBuffer(this.file);
    },
    fetchTrackingDetails(item) {
      window.open(
        this.$router.resolve({
          name: "ClientTrackingDetails",
          query: {
            id: item.tracking_no,
          },
        }).href,
        "_blank"
      );
    },
    clearInput(val) {
      if (val == "from_date") {
        this.from_date = "";
      } else if (val == "to_date") {
        this.to_date = "";
      } else if (val == "client_name") {
        this.client_name = "";
      } else if (val == "tracking_number") {
        this.tracking_number;
      }
    },
  },
};
</script>
<style scoped>
/* Custom CSS to hide the page size selector */

.v-application--is-ltr .v-data-footer__pagination {
  margin-left: auto;
}
</style>
